import React from 'react'
import { PageHeader } from 'SRC/ui'
import { CookiesHelper } from 'SRC/core/cookiesHelper/CookiesHelper'
import { capitalize } from 'SRC/utils/Utils'
import { adFiltersLabels, swapOptions, adsSortTypes, adPriceTypes } from 'SRC/core/constants'
import {
  getProfileLoading,
  getSavedFilters,
  getSavedFiltersLoading
} from '../../../selectors'
import { fetchSavedFilters } from '../../../actions'
import { ProfileApi } from '../../../api'
import withTranslation from 'next-translate/withTranslation'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Preloader } from 'SRC/ui/Preloader'
import { getProfilePaginationParams } from '../../../pagination/selectors'
import { Next, Numbers, Prev } from 'SRC/modules/common/components/Pagination'
import { Links } from 'SRC/modules/common/components/Pagination'
import { formatDateForTableView } from '../../../../../ads/list/functions/functions'
import Router from 'next/router'

import translations from '../../../../../../../public/data/translations.json'

export class SavedFilters extends React.Component {
  constructor(props) {
    super(props)

    this.api = new ProfileApi()
    this.cookies = new CookiesHelper()
  }
  getPageCount = () => Math.ceil((this.props.paginationParams.count) / this.props.paginationParams.countPerPage)

  getBaseUrl = () => {
    return {
      href: {
        pathname: `/profile`,
        query: {
          page: 'sacuvane-pretrage'
        }
      },
      as: `/profil/sacuvane-pretrage`
    }
  }

  getPages = (pageCount = 1) => {
    const pages = []
    const baseUrl = this.getBaseUrl()
    const current = Number(this.props.paginationParams.currentPage)
    for (let i = 1; i <= pageCount; i++) {
      pages.push({
        number: i,
        isCurrent: i === current,
        href: {
          pathname: baseUrl.href.pathname,
          query: { ...baseUrl.href.query, pageNumber: i }
        },
        as: { pathname: baseUrl.as, query: { pageNumber: i } }
      })
    }
    return pages
  }

  getPrevUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) - 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: { pageNumber: Number(this.props.paginationParams.currentPage) - 1 }
    }
  })

  getNextUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) + 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: { pageNumber: Number(this.props.paginationParams.currentPage) + 1 }
    }
  })

  search = (filterId) => {
    const filter = this.props.savedFilters.find(filter => filter.id === filterId)
    const { href, as } = this.getSearchRouterObject(filter)

    console.log('search href', href)
    console.log('search as', as)

    Router.push(href, as)
  }

  getSearchRouterObject = (filter) => {
    const { i18n } = this.props
    const locale = i18n?.lang?.toUpperCase() || 'ME'

    const categorySeo = filter.category ? filter.category.seo : null
    const asUrl = categorySeo ? `/${categorySeo}/${translations.pretraga[locale]}` : `/${translations.pretraga[locale]}`

    const filterValues = this.getFilterValues(filter)

    const hrefQuery = {
      ...filterValues,
      category: categorySeo
    }
    return {
      href: {
        pathname: '/search',
        query: hrefQuery
      },
      as: {
        pathname: asUrl,
        query: filterValues
      }
    }
  }

  getFilterValues = (filter) => {
    const filterValues = {}
    for (let field in filter) {
      if (typeof filter[field] === 'number' || typeof filter[field] === 'string') {
        const omit = ['id', 'user', 'updatedAt', 'createdAt']
        if (!omit.includes(field)) filterValues[field] = filter[field]
      } else {
        if (filter[field]) {
          switch (field) {
            case 'category':
              filterValues[field] = filter[field].seo
              break
            case 'brands':
            case 'products':
              const values = filter[field].map(item => item.id)
              filterValues[field] = JSON.stringify(values)
              break
            case 'brand':
            case 'product':
            case 'country':
            case 'city':
            case 'region':
            case 'location':
              filterValues[field] = filter[field].id
              break
            case 'equipment':
              if (filter[field].length) {
                const equipmentIds = filter[field].map(eq => eq.id)
                filterValues[field] = JSON.stringify(equipmentIds)
              }
              break
            case 'swapps':
              const swappFields = {}
              if (filter[field].category) swappFields.category = filter[field].category.id
              if (filter[field].brand) swappFields.brand = filter[field].brand.id
              if (filter[field].product) swappFields.product = filter[field].product.id
              if (filter[field].specification1) {
                swappFields.specification1 = filter[field].specification1.id
                swappFields.specificationValue1 = filter[field].specificationValue1
              }
              filterValues[field] = JSON.stringify(swappFields)
              break
            case 'sortBy':
              if (typeof filter[field] === 'object' && filter[field].specification) {
                filterValues[field] = JSON.stringify({
                  specification: filter[field].specification.id,
                  order: filter[field].order
                })
              } else {
                if (typeof filter[field] === 'object') {
                  filterValues[field] = `${filter[field].by}${capitalize(filter[field].order)}`
                } else {
                  filterValues[field] = filter[field]
                }
              }
              break
            case 'specifications':
              if (filter[field].length) {
                const specs = []
                for (const spec of filter[field]) {
                  const specId = spec.id.id
                  if (spec.value) specs.push({ id: specId, value: spec.value })
                  if (spec.values) specs.push({ id: specId, values: spec.values })
                  if (spec.range) specs.push({ id: specId, range: spec.range })
                }
                filterValues[field] = JSON.stringify(specs)
              }
              break
            case 'compatibility':
              if (filter[field].category) {
                const compatibility = {
                  category: filter[field].category.id
                }

                if (filter[field].brand) compatibility.brand = filter[field].brand.id
                if (filter[field].product) compatibility.product = filter[field].product.id
                if (filter[field].year) compatibility.year = filter[field].year

                filterValues[field] = JSON.stringify(compatibility)
              }
              
              break
            case 'group':
            case 'userType':
              break
            default:
              filterValues[field] = JSON.stringify(filter[field])
              break
          }
        }
      }
    }
    return filterValues
  }

  getBrands = brands => {
    return <span>{brands.map(brand => brand.name).join(', ')}</span>
  }

  getProducts = products => {
    return <span>{products.map(product => product.model).join(', ')}</span>
  }

  getSwappTitle = (swappName) => {
    const swapp = swapOptions.find(option => option.value === swappName)
    if (swapp) return swapp.title
    return ''
  }

  getEquipmentByGroup = (equipment, group) => {
    const equipmentsByGroup = equipment.filter(eq => eq.grupa === group)
    let values = []
    for (const equipmentByGroup of equipmentsByGroup) {
      values.push(equipmentByGroup.title)
    }

    return values.join(', ')
  }

  getSpecification = (specification) => {
    const { i18n: { t } } = this.props

    const measure = specification.id.measure ? specification.id.measure : ''
    if (specification.value) return `${specification.value} ${measure}`
    if (specification.values) return `${specification.values.join(', ')}`
    if (specification.range) {
      const { from, to } = specification.range

      if (from && to) {
        return `${specification.range.from} - ${specification.range.to} ${measure}`
      } else if (from && !to) {
        return `${t('common:od')} ${specification.range.from} ${measure}`
      } else if (!from && to) {
        return `${t('common:until')} ${specification.range.to} ${measure}`
      } else {
        return ''
      }
    }
  }

  getAdPriceType = (priceTypeId) => {
    const { i18n: { t } } = this.props

    const priceTypeTitle = Object.values(adPriceTypes).filter(priceType => priceType.id === priceTypeId)[0].title

    return t(`common:${priceTypeTitle}`)
  }

  removeSavedSearch = async savedSearchId => {
    const userId = this.cookies.get('userId')
    const token = this.cookies.get('token')
    if (userId && token) {
      const result = await this.api.removeSavedFilter(userId, token, savedSearchId)
      if (result.status === 'ok') {
        this.props.fetchSavedFilters(userId, token, this.props.paginationParams.currentPage, this.props.paginationParams)
      }
    }
  }

  render() {
    const pageCount = this.getPageCount()
    const pages = this.getPages(pageCount)
    const currentPage = Number(this.props.paginationParams.currentPage)
    const isFirstPage = currentPage === 1
    const isLastPage = currentPage === pageCount
    const prevUrl = this.getPrevUrl()
    const nextUrl = this.getNextUrl()
    const totalFilters = this.props.paginationParams.count

    const { i18n: { t } } = this.props

    return ([
      <PageHeader key='header'>{t('common:Sačuvane pretrage')}</PageHeader>,
      <div className='sacuvane-pretrage-akcije' key='sacuvane-pretrage-akcije'>
        <p>{t('common:Sačuvanih pretraga')} [ {totalFilters} ]</p>
        <p>{t('common:Akcije')}</p>
        <p>{t('common:Vrijeme')}</p>
      </div>,
      !this.props.isSavedFiltersLoading
        ? <div className='sacuvane-pretrage-content' key='sacuvane-pretrage-content'>
          {this.props.savedFilters.map(filter =>
            <div key={filter.id} className='sacuvane-pretrage-item'>
              <div className='sacuvane-pretrage-item-header'>
                <p>{t('common:Pretraga')}</p>
                <div className='akcije'>
                  <a href='javascript:void(0)'
                    onClick={() => this.search(filter.id)}>
                    <i className='ico-filter-sacuvaj-pretragu ico' />{t('common:Pretraži')}
                  </a>

                  <a href='javascript:void(0)'
                    onClick={() => this.removeSavedSearch(filter.id)} >
                    <i className='ico-obrisati ico' /> {t('common:Obriši')}
                  </a>
                </div>
                <p className='vreme'>{formatDateForTableView(filter.createdAt, (text) => t(`common:${text}`))}</p>
              </div>
              <div className='sacuvane-pretrage-item-content'>
                <ul>
                  {Object.keys(filter).filter(key => key !== 'equipment').map(filterField => {
                    const filterValue = filter[filterField]

                    switch (filterField) {
                      case 'fullText':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{filterValue}</span>
                          </li>) : null
                      case 'new24':
                      case 'loweredPrice':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{t('common:Da')}</span>
                          </li>) : null
                      case 'priceType':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{this.getAdPriceType(filterValue)}</span>
                          </li>) : null
                      case 'condition':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{filterValue === 'new' ? t('common:Novo') : t('common:Polovno')}</span>
                          </li>) : null
                      case 'swapp':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{this.getSwappTitle(filterValue)}</span>
                          </li>) : null
                      case 'adUser':
                      case 'country':
                      case 'region':
                      case 'city':
                      case 'location':
                      case 'userType':
                      case 'brand':
                        return filterValue ? <li key={filterField}>
                          <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                          <span>{filterValue.name}</span>
                        </li> : null
                      case 'product':
                        return filterValue ? <li key={filterField}>
                          <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                          <span>{filterValue.model}</span>
                        </li> : null
                      case 'brands':
                        return filterValue && filterValue.length ? <li key={filterField}>
                          <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                          {this.getBrands(filterValue)}
                        </li> : null
                      case 'products':
                        return filterValue && filterValue.length ? <li key={filterField}>
                          <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                          {this.getProducts(filterValue)}
                        </li> : null
                      case 'category':
                      case 'group':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{filterValue.title}</span>
                          </li>) : null
                      case 'price':
                        return filterValue !== null ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>
                              {filterValue[0] ? `${filterValue[0]}€ - ` : ''}
                              {filterValue[1]}€
                            </span>
                          </li>) : null
                      case 'sortBy':
                        let text = ''
                        if (typeof filterValue === 'string') text = t(`common:adssorttypes_${[filterValue]}`)
                        if (typeof filterValue === 'object') {
                          if (filterValue.specification) {
                            text = `${filterValue.specification.title} - ${filterValue.order}`
                          }
                          if (filterValue.by) text = t(`common:adssorttypes_${filterValue.by}${filterValue.order}`)
                        }
                        return filterValue ? (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>{text}</span>
                          </li>) : null
                      case 'swapps':
                        console.log('swapps filterValue', filterValue)
                        const swappsItems = []
                        if (filterValue.category) swappsItems.push(filterValue.category.title)
                        if (filterValue.brand) swappsItems.push(filterValue.brand.name)
                        if (filterValue.product) swappsItems.push(filterValue.product.model)
                        if (filterValue.specificationValue1) swappsItems.push(filterValue.specificationValue1)
                        return (
                          <li key={filterField}>
                            <p>{t(`common:${adFiltersLabels[filterField]}`)}:</p>
                            <span>
                              {swappsItems.join(' - ')}
                            </span>
                          </li>)
                      case 'specifications':
                        return filterValue.length ? (
                          filterValue.map(specification =>
                            <li key={specification.pk}>
                              <p>{specification.id.title}:</p>
                              <span>
                                {this.getSpecification(specification)}
                              </span>
                            </li>)) : null
                      case 'compatibility':
                        return (
                          <>
                            {filterValue?.category?.title ? (
                              <li key={filterField}>
                                <p>{t('common:Odgovara Kategoriji')}:</p>
                                <span>{filterValue.category.title}</span>
                              </li>
                            ) : null}

                            {filterValue?.brand?.name ? (
                              <li key={filterField}>
                                <p>{t('common:Odgovara Proizvođaču')}:</p>
                                <span>{filterValue.brand.name}</span>
                              </li>
                            ) : null}

                            {filterValue?.product?.model ? (
                              <li key={filterField}>
                                <p>{t('common:Odgovara Modelu')}:</p>
                                <span>{filterValue.product.model}</span>
                              </li>
                            ) : null}

                            {filterValue?.year ? (
                              <li key={filterField}>
                                <p>{t('common:Odgovara Godištu')}:</p>
                                <span>{filterValue.year}</span>
                              </li>
                            ) : null}
                            
                          </>
                        )
                      case 'cities':
                        if (Array.isArray(filterValue) && filterValue.length) {
                          return (
                            <li key={filterField}>
                              <p>{adFiltersLabels.city}:</p>
                              <span>
                                {filterValue.map(city => city.name).join(', ')}
                              </span>
                            </li>
                          )
                        }
                        return null
                      default: break
                    }
                  })}
                  {Object.keys(filter).filter(key => key === 'equipment').map(filterField => {
                    const filterValue = filter[filterField]

                    const security = this.getEquipmentByGroup(filterValue, 'security')
                    const history = this.getEquipmentByGroup(filterValue, 'history')
                    const addition = this.getEquipmentByGroup(filterValue, 'addition')
                    return [
                      security.length
                        ? <li key='security'>
                          <p>{t('common:Sigurnost')}:</p>
                          <span>{security}</span>
                        </li> : null,
                      history.length
                        ? <li key='history'>
                          <p>{t('common:Istorija vozila')}:</p>
                          <span>{history}</span>
                        </li> : null,
                      addition.length
                        ? <li key='addition'>
                          <p>{t('common:Dodatna oprema')}:</p>
                          <span>{addition}</span>
                        </li> : null
                    ]
                  })}
                </ul>
              </div>
            </div>
          )}
        </div> : <Preloader />,
      pages ? (
        <Links
          isFirstPage={isFirstPage}
          isLastPage={isLastPage}
          prevUrl={prevUrl}
          nextUrl={nextUrl}
          pages={pages}
        />
      ) : null,
      this.props.isLoading ? <Preloader /> : null
    ])
  }
}

const mapStateToProps = state => ({
  isLoading: getProfileLoading(state),
  isSavedFiltersLoading: getSavedFiltersLoading(state),
  savedFilters: getSavedFilters(state),
  paginationParams: getProfilePaginationParams(state)
})

SavedFilters.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isSavedFiltersLoading: PropTypes.bool.isRequired,
  savedFilters: PropTypes.array.isRequired,
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    countPerPage: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired
  }),
  fetchSavedFilters: PropTypes.func.isRequired
}

SavedFilters.defaultProps = {
  isLoading: false,
  isSavedFiltersLoading: false,
  savedFilters: []
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, { fetchSavedFilters })
)

export default enhance(SavedFilters)
